<!-- service-opened dialogs do not wire a custom titlebar's X; the X closes and
     KEEPS a staged payload (reopening is instant) -- only Discard drops it -->
<kendo-dialog-titlebar (close)="onClose()">Send to RARS</kendo-dialog-titlebar>

<div *ngIf="loading" class="spinner-wrapper">
    <i class="fas fa-2x fa-spinner fa-spin"></i>
    <div>Preparing the payload&hellip;</div>
</div>

<div *ngIf="!loading">
    <div class="publish-summary">
        <div class="scope-line">
            Are you sure you wish to send these overrides to RARS immediately?
        </div>
        <div *ngIf="job">
            {{ job.journeyCount }} journey(s) &middot; {{ job.requestCount }} RARS request(s)
            <span *ngIf="job.startDate">
                &middot; {{ job.startDate }} to {{ job.endDate }}
            </span>
            <span *ngIf="job.stagedDate"> &middot; prepared {{ job.stagedDate }}</span>
        </div>
        <div *ngIf="total > 0" class="tick-line">
            {{ selectedCount }} of {{ total }} journey(s) ticked to send.
            Untick a journey to leave its allocations out of this send.
        </div>
    </div>

    <div *ngIf="isStale" class="publish-warning">
        <i class="fas fa-exclamation-triangle"></i>
        These numbers were prepared a while ago and bookings may have moved since.
        Discard them if they should no longer be sent &mdash; the next scheduled
        run sends freshly derived numbers either way.
    </div>

    <div *ngIf="isBlocked" class="publish-warning">
        <i class="fas fa-ban"></i>
        Sending to RARS is currently disabled ({{ job.note }}). Nothing has been sent.
    </div>

    <div *ngIf="errorMessage" class="publish-error">{{ errorMessage }}</div>

    <!-- one row per journey; the detail template (Kendo adds the +/- expand cell
         for it) lists the journey's buckets -->
    <kendo-grid *ngIf="total > 0"
                [data]="gridView"
                [skip]="skip"
                [pageSize]="pageSize"
                [pageable]="true"
                [scrollable]="'scrollable'"
                [height]="420"
                [rowClass]="rowClass"
                (pageChange)="onPageChange($event)">
        <kendo-grid-column title="Send" [headerClass]="'ra-grid-header'" width="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                <input type="checkbox" class="publish-tick"
                       [checked]="isIncluded(dataItem)"
                       (change)="toggleJourney(dataItem)"
                       title="Untick to leave this journey out of the send">
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="departureDate" title="Departure" [headerClass]="'ra-grid-header'" width="100"></kendo-grid-column>
        <kendo-grid-column field="rsid" title="RSID" [headerClass]="'ra-grid-header'" width="100"></kendo-grid-column>
        <kendo-grid-column field="journeyOrigin" title="From" [headerClass]="'ra-grid-header'" width="65"></kendo-grid-column>
        <kendo-grid-column field="journeyDestination" title="To" [headerClass]="'ra-grid-header'" width="65"></kendo-grid-column>
        <kendo-grid-column field="passengerClass" title="Class" [headerClass]="'ra-grid-header'" width="80"></kendo-grid-column>
        <!-- why the journey is in the payload: the applied rule(s), Reopt, or a
             bulk override. A rule list can be long, so the full text is on hover. -->
        <kendo-grid-column field="source" title="Source" [headerClass]="'ra-grid-header'" width="170">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="publish-source" [title]="dataItem.source">{{ dataItem.source }}</span>
            </ng-template>
        </kendo-grid-column>
        <!-- the UIC pair is what RARS actually receives, so show it rather than
             leaving the user to guess the mapping -->
        <kendo-grid-column field="odPair" title="OD Pair (UIC)" [headerClass]="'ra-grid-header'" width="130"></kendo-grid-column>
        <kendo-grid-column field="bucketCount" title="Buckets" [headerClass]="'ra-grid-header'" width="75"></kendo-grid-column>
        <kendo-grid-column title="Grouped" [headerClass]="'ra-grid-header'" width="90">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.isParentOd">
                    parent of {{ dataItem.childOdCount }}
                </span>
            </ng-template>
        </kendo-grid-column>

        <ng-template kendoGridDetailTemplate let-dataItem>
            <kendo-grid class="publish-buckets"
                        [data]="dataItem.buckets"
                        [scrollable]="'none'">
                <kendo-grid-column field="bucketCode" title="Bucket" [headerClass]="'ra-grid-header'" width="90"></kendo-grid-column>
                <kendo-grid-column field="currentLimit" title="Current" [headerClass]="'ra-grid-header'" width="90"></kendo-grid-column>
                <kendo-grid-column field="limitSent" title="New" [headerClass]="'ra-grid-header'" width="90"></kendo-grid-column>
                <kendo-grid-column field="sendStatus" title="Status" [headerClass]="'ra-grid-header'" width="110"></kendo-grid-column>
            </kendo-grid>
        </ng-template>
    </kendo-grid>

    <div *ngIf="total === 0 && !errorMessage" class="publish-warning">
        There is nothing to send for this re-optimization.
    </div>
</div>

<kendo-dialog-actions class="ra-dialog-button-group">
    <button class="k-button ra-dialog-button" (click)="onClose()">Close</button>
    <button class="k-button ra-dialog-button" [disabled]="!canDiscard" (click)="onDiscard()"
            title="Do not send now; wait for the overnight run to send the latest numbers">
        Discard
    </button>
    <button class="k-button ra-dialog-button" [disabled]="!canSend" (click)="onSend()">
        {{ sending ? 'Sending&hellip;' : 'Send to RARS' }}
    </button>
</kendo-dialog-actions>
